import { Box, Flex } from '@chakra-ui/react';

import { Iteration } from 'Component/others';
import SkeletonComponent from 'UiKit/skeleton';

import styles from './styles.module.css';

const GiveawayItemSkeleton = () => {
  return (
    <Box className={styles['content__container']}>
      <SkeletonComponent height="16px" width="120px" mb="12px" />
      <Box border="1px solid var(--color-neutral20)" borderRadius="8px" padding="12px" mb="8px">
        <SkeletonComponent height="14px" width="80px" mb="12px" />
        <Flex gap="8px" alignItems="center" mb="12px">
          <SkeletonComponent height="48px" width="48px" borderRadius="4px" />
          <Box flex={1}>
            <SkeletonComponent height="14px" width="70%" mb="6px" />
            <SkeletonComponent height="12px" width="40%" />
          </Box>
          <Box textAlign="right">
            <SkeletonComponent height="12px" width="30px" mb="4px" />
            <SkeletonComponent height="16px" width="24px" />
          </Box>
        </Flex>
        <SkeletonComponent height="12px" width="50px" mb="8px" />
        <SkeletonComponent height="14px" width="60%" mb="6px" />
        <SkeletonComponent height="14px" width="40%" />
      </Box>
    </Box>
  );
};

const GiveawayContentSkeleton = () => {
  return (
    <Flex flexDirection="column" gap="12px" padding="12px">
      <Iteration
        items={[1, 2, 3]}
        render={(item) => <GiveawayItemSkeleton key={item} />}
      />
    </Flex>
  );
};

export default GiveawayContentSkeleton;
